import React from "react";

// core components
import Navbar from "../components/Navbar.js";
import LandingPageHeader from "components/Headers/LandingPageHeader.js";
import DemoFooter from "../components/Footer.js";
import NAConferenceSections from "components/na/NAConferenceSections.js";
import Photos from "../components/Photos.js";

import Speaker from "../components/SpeakerCard.js";
import SponsorNew from "../components/SponsorNew.js";

import Editions from "components/Editions.js";
import { darkSectionBg } from "components/darkSectionTokens";

function Home() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });

  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928;
  const bg = require("assets/images/bg.jpg");

  return (
    <>
      <Navbar />
      <LandingPageHeader />
      <NAConferenceSections />
      <div style={darkSectionBg(bg, size)} className="section section-with-space pt-0 pb-0">
        <section id="speakers" />
        <Speaker />

        <section id="partners" />
        <SponsorNew />

        <Photos />

        <section id="editions" />
        <Editions />
      </div>

      <DemoFooter />
    </>
  );
}

export default Home;
